export default "__VITE_ASSET__DJrobCYt__"